export const BOOKING_OVERRIDES = {};
